module.exports = __webpack_public_path__ + "static/physical-health-adbf96e801daa07b43e0d7d6f1f5e1dd.jpg";